import {
  ICertificateOrganizationReducer,
  ICertificateOrganization,
} from 'models/CertificateOrganization'
import { Action } from 'redux'
import { isType } from 'ts-action'
import { updateArray, deleteFromArray } from 'helpers/helperFunctions'
import {
  GetCertificateOrganizations,
  CertificateOrganizationsFetching,
  UpdateCertificateOrganization,
  DeleteCertificateOrganization,
  AddCertificateOrganization,
} from './actions'

const initialState: ICertificateOrganizationReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: [],
}

export const certificateOrganizationsReducer = (
  state = initialState,
  action: Action
): ICertificateOrganizationReducer => {
  if (isType(action, GetCertificateOrganizations)) {
    const { payload } = action
    return {
      ...state,
      meta: payload.meta,
      data: payload.data,
    }
  }
  if (isType(action, AddCertificateOrganization)) {
    const { payload } = action
    const { data } = state
    const newArray = [payload.data, ...data]
    return {
      ...state,
      data: newArray,
    }
  }
  if (isType(action, UpdateCertificateOrganization)) {
    const { payload } = action
    const { data } = state
    const formattedArray = updateArray<ICertificateOrganization>(data, payload.data)
    return {
      ...state,
      data: formattedArray,
    }
  }
  if (isType(action, DeleteCertificateOrganization)) {
    const { payload } = action
    const { data } = state
    const formattedArray = deleteFromArray<ICertificateOrganization>(data, payload)
    return {
      ...state,
      data: formattedArray,
    }
  }

  if (isType(action, CertificateOrganizationsFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }
  return state
}
